import React, { useState } from 'react';
import { StarCounter } from '../modals/StarCounter';
import Avatar, { AvatarSizes } from '../Avatar/Avatar';
import moment from 'moment';
import { TRANSLATIONS } from '../../../translations';
import Typography, { TypographyStates, TypographyVariants, TypographyWeights } from '../../ui-components/Typography/Typography';

const ReviewMediaLabel = ({
    score, firstName, lastName, date, profileImage
}) => {
    //TODO: manage different colors as props

    return (
        <div className="bg-mask-fading z-index-1 absolute top-0 left-0 pt-xs pr-xs pl-xs pb-xs w-100%"
            style={{ pointerEvents: 'none' }}>
            <div className="d-flex items-baseline gap-base">
                <Avatar
                    size={AvatarSizes.xxs}
                    firstName={firstName}
                    profileImage={profileImage}
                />
                <div>
                    <div className='d-flex items-center gap-base'>
                        <Typography
                            variant={TypographyVariants.p2}
                            weight={TypographyWeights['bold']}
                            state={TypographyStates.inverted}
                        >
                            {`${firstName} ${lastName}`}
                        </Typography>
                        <StarCounter score={score} />
                    </div>

                    <Typography
                        variant={TypographyVariants.p4}
                        state={TypographyStates.inverted}
                    >
                        {TRANSLATIONS.ACTIVITY_DATE}: {moment(date).format('DD/MM/YYYY')}
                    </Typography>
                </div>
            </div>
        </div>
    );
};


ReviewMediaLabel.propTypes = {
};

export default ReviewMediaLabel;